import { NextRequest } from 'next/server'

export interface LogContext {
  requestId: string
  userId?: string
  method: string
  path: string
  ip: string
  userAgent?: string
  startTime: number
}

// Server-side AsyncLocalStorage (Node.js only)
let logContext: any = null
let AsyncLocalStorage: any = null

// Only import AsyncLocalStorage on server-side
if (typeof window === 'undefined') {
  try {
    AsyncLocalStorage = require('async_hooks').AsyncLocalStorage
    logContext = new (AsyncLocalStorage as any)()
  } catch (error) {
    // AsyncLocalStorage not available, use fallback
    console.warn('AsyncLocalStorage not available, using fallback context')
  }
}

export function createLoggingMiddleware() {
  return async (request: NextRequest) => {
    const context: LogContext = {
      requestId: request.headers.get('x-request-id') || crypto.randomUUID(),
      method: request.method,
      path: request.nextUrl.pathname,
      ip: request.headers.get('x-forwarded-for') || 'unknown',
      userAgent: request.headers.get('user-agent') || undefined,
      startTime: Date.now(),
    }
    
    if (logContext && AsyncLocalStorage) {
      return logContext.run(context, () => {
        return context
      })
    }
    
    return context
  }
}

export function getLogContext(): LogContext | undefined {
  if (logContext && typeof window === 'undefined') {
    return logContext.getStore()
  }
  
  // Client-side fallback - return minimal context
  return {
    requestId: 'client-' + Date.now(),
    method: 'CLIENT',
    path: typeof window !== 'undefined' ? window.location.pathname : 'unknown',
    ip: 'unknown',
    startTime: Date.now(),
  }
}

export function updateLogContext(updates: Partial<LogContext>): void {
  if (logContext && typeof window === 'undefined') {
    const context = logContext.getStore()
    if (context) {
      Object.assign(context, updates)
    }
  }
  // Client-side: no-op (context is not persistent)
}
